import Cliente from "../mapper/Cliente";
import { db } from "../script/Fetch";
import FirestoreDbQueries from "./FirestoreDbQueries";
import { Tavolo } from "../mapper/Tavolo";

export default class TavoloDbQueries extends FirestoreDbQueries<Tavolo> {
    notify(): void {
        throw new Error("Method not implemented.");
    }
    
    async selectByRistoranteId(ristoranteId: string) {
        let snapshot = await  db.collection("ristoranti").doc(ristoranteId).collection("tavoli").get();
        return snapshot.docs.map(doc => {
            return Tavolo.convertFromFirestore(doc.id, doc.data());
        });
    }

    convertFromFirestore(documentId: string, firestoreObject: firebase.firestore.DocumentData): Tavolo {
        return Tavolo.convertFromFirestore(documentId, firestoreObject);
    }

    convertToFirestore(object: Tavolo) {
        return Tavolo.convertToFirestore(object);
    }
}